// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__3H4cc","location":"Header_location__Bh4Cg"};